import { useGetLoggedInUser } from '@services/api/users';
import { AvatarWithFallback } from '@components/Avatars/AvatarWithFallback';
import { mdiAccountBoxOutline, mdiCameraPlusOutline } from '@mdi/js';

type ProfilePictureAvatarProps = {
  addPictureIcon?: boolean;
  whiteBackground?: boolean;
};

export const ProfilePictureAvatar: React.FC<ProfilePictureAvatarProps> = ({
  addPictureIcon = false,
  whiteBackground,
}) => {
  const { user } = useGetLoggedInUser();

  return (
    <AvatarWithFallback
      uri={user?.logotypeUri}
      fallbackIcon={addPictureIcon ? mdiCameraPlusOutline : mdiAccountBoxOutline}
      whiteBackground={whiteBackground}
    />
  );
};
